import React from 'react';
import { Link } from 'react-router-dom';
import { useReveal } from '../lib/useReveal';

export default function Gift() {
  const ref = useReveal();
  return (
    <div ref={ref} data-testid="gift-page" className="pt-36 sm:pt-44 lg:pt-56">
      <section className="grid lg:grid-cols-12 gap-0 items-stretch">
        <div className="lg:col-span-6 media-card relative min-h-[420px] lg:min-h-[640px] order-2 lg:order-1">
          <img src="/assets/photos/menu-card.jpg" alt="A handwritten menu beside crystal glasses" className="absolute inset-0 w-full h-full object-cover" />
        </div>
        <div className="lg:col-span-6 px-6 lg:px-16 py-12 lg:py-24 flex items-center order-1 lg:order-2">
          <div className="max-w-xl reveal">
            <div className="tdt-eyebrow mb-5">Gift Experiences</div>
            <h1 className="font-serif font-light text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[color:var(--tdt-ink)] mb-8">
              The gift of a curated evening.
            </h1>
            <p className="text-base sm:text-lg lg:text-lg leading-relaxed text-[color:var(--tdt-muted)] mb-5">
              A Tour de Taste experience is an enduring gift — a privately hosted evening, a long lunch at a wine estate, or a bespoke culinary day, all designed around the recipient.
            </p>
            <p className="text-base sm:text-lg lg:text-lg leading-relaxed text-[color:var(--tdt-muted)]">
              Each gift is presented as a beautifully written invitation, with the experience itself curated in consultation with the recipient once they wish to redeem it.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[color:var(--tdt-cream)] py-16 sm:py-14 sm:py-18 lg:py-32">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-6 lg:px-12 grid md:grid-cols-3 gap-10 lg:gap-14">
          {[
            ['The Private Table Gift', 'A privately hosted evening of aperitifs, tastings and chef’s table dining for two. From $1,200.'],
            ['The Cellar & Table Gift', 'A sommelier-led wine and dining experience with private tastings and paired courses. From $450 per guest.'],
            ['The Bespoke Gift', 'A fully tailored gift designed in consultation with you — weekend itineraries, proposal evenings, milestone moments. Custom quoted.'],
          ].map(([t, b], i) => (
            <div key={t} className="reveal text-center md:text-left" data-testid={`gift-${i}`}>
              <div className="hr-gold mb-6 mx-auto md:mx-0" />
              <h3 className="font-serif text-2xl lg:text-3xl text-[color:var(--tdt-ink)] mb-4 leading-snug">{t}</h3>
              <p className="text-sm leading-relaxed text-[color:var(--tdt-muted)]">{b}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[color:var(--tdt-ivory)] py-16 sm:py-14 sm:py-18 lg:py-32 text-center">
        <div className="max-w-[820px] mx-auto px-5 sm:px-6 lg:px-12 reveal">
          <div className="tdt-eyebrow mb-5">Arrange a gift</div>
          <h2 className="font-serif font-light text-3xl sm:text-4xl md:text-5xl leading-[1.05] text-[color:var(--tdt-ink)] mb-6">
            Begin with a private enquiry.
          </h2>
          <p className="text-[color:var(--tdt-muted)] leading-relaxed mb-10">
            Tell us about the recipient and the moment you wish to mark. We will respond personally and arrange every detail.
          </p>
          <Link to="/enquire" data-testid="gift-enquire-btn" className="btn-pill btn-gold">Enquire Privately</Link>
        </div>
      </section>
    </div>
  );
}
